import { axios } from "../config/axios";
import {
  CreateBlockedUserDto,
  IBlockedUser,
  UpdateBlockedUserDto
} from "../interfaces/endpoints/IBlockedUser";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import { serialize } from "../utils/serializeToQueryString";

export type GetAllBlockedUsersParamsType = {
  searchKeyword?: string;
};

export const getAllBlockedUsers = async (
  att: GetAllBlockedUsersParamsType
): Promise<IAxiosResponse<IBlockedUser[]>> => {
  return axios.get<IBlockedUser[]>(`/v1/BlockedUser${serialize(att)}`);
};

export const createBlockedUser = async (
  body: CreateBlockedUserDto
): Promise<number> => {
  return axios.post("/v1/BlockedUser", body);
};

export const updateBlockedUser = async (
  id: number,
  body: UpdateBlockedUserDto
): Promise<number> => {
  return axios.put(`/v1/BlockedUser/${id}`, body);
};

export const deleteBlockedUser = async (id: number): Promise<boolean> => {
  return axios.delete(`/v1/BlockedUser/${id}`);
};

export const invalidateBlockedUserCache = async (): Promise<boolean> => {
  return axios.post("/v1/BlockedUser/InvalidateCache");
};
